module.exports = __webpack_public_path__ + "img/store-settings.171f7513.svg";